<template>  
    <div class="SubjectsDialog">
      <el-dialog  
          title="科目选择"
          width="900px"
          append-to-body
          :visible.sync="visible" 
          @close="$emit('update:show', false)" 
          :show="show">
          <div class="content_box">
            <div class="content_top">
              <el-input v-model="searchText" size="mini" placeholder="输入名称/编号" class="search_input"></el-input>
              <!-- <el-checkbox v-model="showLeve" style="margin-left:10px;">显示层级结构</el-checkbox> -->
              <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
            </div>
            <div class="content_infor_box">
                <baseTable class="basetable_sty" :configData="configData" :tableData="tableData" @rowdblclick="rowdblclick" @clickIcon="clickIcon"/>
            </div>
            <!-- 分页  -->
            <el-pagination
            style="width:70%;margin:10px auto 0;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20,50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
            ></el-pagination>
          </div>
      </el-dialog>
    </div> 

</template>  

<script>
import tool from "@/utils/tool"; //本地缓存存取
const bankData = [
    {label:'科目名称',Key:'FullName'},
    {label:'科目编码',Key:'UserCode'},
    {label:'助记码',Key:'PyNo'},
    {label:'备注',Key:'Memo'},
]
export default {
    data () {  
        return {
            visible: this.show,
            searchText:'',//收索内容
            // showLeve:false,//是否显示层级
            tableData:[],//table表格数据
            configData:[...bankData],//配置项
            // 分页
            currentPage: 1, //当前页码
            total: 0, //总页数
            pageSize: 10, //每页显示数量
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
    },
    methods:{
        // 请求table表格数据
        InitTable(){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                Keywords:this.searchText,//模糊查询参数
                style:this.$attrs.pargam.SubType,//0所有科目，1银行账户，2费用类型，3，其他收入 4、费用科目 5、收入科目,
                type:1,//type=0查询所有一级数据  type=1查询所有末端数据
                ClearTotal:1,//0 不清空Total   1 Total清空为0
                pagesize:this.pageSize,
                pagenum:this.currentPage,
            }
            this.request.post('/index/Subject/search', {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    // console.log(res)
                    this.tableData = res.data;
                    this.total = res.count;
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 点击收索按钮
        searchClick(){
          this.InitTable();
        },
        // 点击table头部图标返回上一级
        clickIcon(){
            this.InitTable();
        },
        // 双击table行元素
        rowdblclick(data){
            this.$emit('chooseBack',data);
            this.$emit('update:show', false);
        },
        // 当前页显示条数发生变化时
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.InitTable();
        },
        // 当前页发生变化时
        handleCurrentChange(val) {
            // console.log(val);
            this.currentPage = val;
            this.InitTable();
        },
    },
    watch: {  
        show (){  
            this.visible = this.show;
            if(this.visible){
                this.InitTable();
            }
        },
    },
    // 创建生命周期钩子函数
    mounted() {
        // 初始化数据
        this.InitTable();
    },

};  
</script>

<style lang="less" scoped>
.SubjectsDialog{

}
.basetable_sty{
    width: 100%;
}
.search_btn{margin-left: 20px;}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/SubjectsDialog/SubjectsDialog.vue